module.exports = __webpack_public_path__ + "assets/media/july.65649506.svg";